export const SETTINGS_VALUES = {
  RELEASE_DETECTION: {
    API_RELEASE_DETECTION: 'reported'
  }
};

export const API_TOKENS_STATUS = {
  ACTIVE: 'active',
  REVOKED: 'revoked'
};
